var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58.0001,
    r: 58,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 69.6C70.813 69.6 81.2 59.213 81.2 46.4C81.2 33.587 70.813 23.2 58 23.2C45.187 23.2 34.8 33.587 34.8 46.4C34.8 59.213 45.187 69.6 58 69.6ZM58 58C64.4065 58 69.6 52.8065 69.6 46.4C69.6 39.9935 64.4065 34.8 58 34.8C51.5935 34.8 46.4 39.9935 46.4 46.4C46.4 52.8065 51.5935 58 58 58Z",
    fill: "#DCDFEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.3715 104.723C106.703 94.1629 116 77.1672 116 58C116 25.9675 90.0325 0 58 0C25.9675 0 0 25.9675 0 58C0 77.1672 9.29748 94.1629 23.6285 104.723C23.8922 104.917 24.1575 105.109 24.4245 105.299C27.0278 107.151 29.7906 108.792 32.6881 110.2C40.3369 113.916 48.9251 116 58 116C67.075 116 75.6631 113.916 83.3119 110.2C83.4674 110.124 83.6225 110.048 83.7772 109.971C86.8011 108.469 89.6754 106.71 92.3715 104.723ZM88.3265 93.1188C98.1707 84.6104 104.4 72.0327 104.4 58C104.4 32.374 83.626 11.6 58 11.6C32.374 11.6 11.6 32.374 11.6 58C11.6 72.0327 17.8293 84.6104 27.6734 93.1188C33.6438 82.5415 44.9879 75.4 58 75.4C71.0121 75.4 82.3561 82.5415 88.3265 93.1188ZM78.6287 99.5736C74.7741 92.1057 66.9833 87 58 87C49.0167 87 41.2259 92.1057 37.3713 99.5736C43.5851 102.663 50.5897 104.4 58 104.4C65.4103 104.4 72.4149 102.663 78.6287 99.5736Z",
    fill: "#DCDFEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/photo_placeholder.1dd21ea02fa3b5f31000f7be89c4a96b.svg";
export { ForwardRef as ReactComponent };